import { Link, NavLink } from 'react-router';
import { HardHat } from 'lucide-react';
import { APP_NAME } from '@helfr/domain';

/**
 * Sdílená hlavička veřejných stránek (landing, Funkce): záložky s vyznačenou
 * aktivní stránkou — návštěvník vždy vidí, kde je a jak se vrátí na úvod
 * (záložka Úvod + logo). Vpravo vstupy do aplikace.
 */
export function VerejnaHlavicka() {
  const zalozka = ({ isActive }: { isActive: boolean }) =>
    `inline-flex min-h-11 items-center rounded-lg px-3 font-semibold transition-colors duration-100 ${
      isActive ? 'bg-white/15 text-white' : 'text-primary-tint hover:bg-white/10 hover:text-white'
    }`;

  return (
    <header className="bg-primary">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-x-4 gap-y-2 px-6 py-4">
        <Link
          to="/"
          className="flex items-center gap-2.5 text-white"
          aria-label="Na úvodní stránku"
        >
          <span className="flex size-9 items-center justify-center rounded-lg bg-accent text-text-heading">
            <HardHat size={20} strokeWidth={2} aria-hidden="true" />
          </span>
          <span className="text-lg font-bold tracking-widest uppercase">{APP_NAME}</span>
        </Link>

        <nav aria-label="Veřejné stránky" className="order-3 flex items-center gap-1 sm:order-none">
          <NavLink to="/" end className={zalozka}>
            Úvod
          </NavLink>
          <NavLink to="/funkce" className={zalozka}>
            Funkce
          </NavLink>
          <NavLink to="/scenare" className={zalozka}>
            Scénáře
          </NavLink>
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/login"
            className="min-h-11 content-center px-2 font-semibold text-white underline-offset-2 hover:underline"
          >
            Přihlásit se
          </Link>
          <Link
            to="/registrace"
            className="hidden min-h-11 items-center rounded-lg bg-accent px-4 font-bold text-text-heading transition-colors duration-100 hover:bg-accent-hover sm:inline-flex"
          >
            Založte firmu zdarma
          </Link>
        </div>
      </div>
    </header>
  );
}
